'use strict';

/**
 *
 * @name: seasonsAnalytics
 *
 */

function SeasonsAnalyticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function viewFullSeries(series, name, title) {

    var properties = {
      eventAction: $location.path() + ' | ' + name + ' | ' + title,
      attributes: {
        label: 'view full series'
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  function watchNow(series, name, title) {

    var properties = {
      eventAction: $location.path() + ' | ' + name + ' | ' + title,
      attributes: {
        label: series.id + ' | ' + series.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  return {
    viewFullSeries: viewFullSeries,
    watchNow: watchNow,
  };
}

export default SeasonsAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/seasons/seasons-analytics.factory.js